module.exports = "<header class=\"container-fluid\">\n  <div class=\"row\">\n    <span id=\"logoLink\">\n      <span>Mindent egy helyen, teljes kiszolgálással!</span>\n    </span>\n    <!-- <div class=\"language-selector\">\n      <span class=\"language\">HU</span>\n      <a href=\"#\" class=\"language\">EN</a>\n    </div> -->\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/header/header.component.html
// module id = ../../../../../src/app/header/header.component.html
// module chunks = main